import { Box, useColorModeValue } from "@chakra-ui/react";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import BoletoComponent from "../components/index";

interface BoletoPreviewWrapperProps {
  settings: {
    logo?: string;
    emailMessage?: string;
    smsMessage?: string;
    whatsAppMessage?: string;
    notificationEnabled?: boolean;
    colorHeader?: string;
  };
}

// Largura real do boleto renderizado (ver components/index.tsx)
const BOLETO_WIDTH = 1060;

export default function BoletoPreview({ settings }: BoletoPreviewWrapperProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);
  const [contentHeight, setContentHeight] = useState(0);

  const cardBg = useColorModeValue("white", "gray.800");

  useLayoutEffect(() => {
    const updateScale = () => {
      if (!containerRef.current) return;
      // desconta o padding horizontal do container (p={4} = 16px de cada lado)
      const available = containerRef.current.clientWidth - 32;
      const finalScale = Math.min(available / BOLETO_WIDTH, 1);
      setScale(finalScale > 0 ? finalScale : 1);

      if (contentRef.current) {
        setContentHeight(contentRef.current.offsetHeight);
      }
    };

    updateScale();
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, [settings]);

  return (
    <Box
      ref={containerRef}
      width="100%"
      height="100%"
      minH="600px"
      display="flex"
      justifyContent="center"
      alignItems="start"
      overflow="auto"
      borderRadius="2xl"
      boxShadow="xl"
      bg={cardBg}
      p={4}
    >
      {/* ocupa exatamente o espaço do boleto escalado, garantindo centralização */}
      <Box
        width={`${BOLETO_WIDTH * scale}px`}
        height={contentHeight ? `${contentHeight * scale}px` : undefined}
      >
        <Box
          ref={contentRef}
          width={`${BOLETO_WIDTH}px`}
          transform={`scale(${scale})`}
          transformOrigin="top left"
        >
          <BoletoComponent
            logo={settings.logo}
            colorHeader={settings.colorHeader}
            emailMessage={settings.emailMessage}
            smsMessage={settings.smsMessage}
            whatsAppMessage={settings.whatsAppMessage}
            notificationEnabled={settings.notificationEnabled}
          />
        </Box>
      </Box>
    </Box>
  );
}
